'use client'

import { useTranslation } from '../../hooks/useTranslation';
export default function RentCar() {
  const { t } = useTranslation();
  return (
    <section className="relative bg-[var(--background)] text-white overflow-hidden min-h-[85vh] flex items-center py-8 sm:py-12 md:py-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 md:gap-12 items-center">
          {/* Car Image Section */}
          <div className="relative order-2 lg:order-1">
            <div className="relative z-10 ml-0 sm:ml-4 md:ml-[30px]">
              <img 
                src="/images/rent.png" 
                alt="Luxury Audi Car" 
                className="w-full h-auto object-contain max-w-md sm:max-w-lg md:max-w-full mx-auto lg:mx-0"
              />
            </div>
            {/* Glow effect behind car */}
            <div className="absolute inset-0 bg-[var(--background)] transform scale-110"></div>
          </div>

          {/* Content Section */}
          <div className="space-y-6 sm:space-y-8 order-1 lg:order-2">
            <div>
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold mb-6 sm:mb-8 leading-tight text-center lg:text-left">
                {t('steps.title')}
              </h2>
            </div>

            {/* Steps */}
            <div className="space-y-4 sm:space-y-6">
              {/* Step 1 */}
              <div className="flex items-start space-x-3 sm:space-x-4">
                <div className="flex-shrink-0 w-16 h-16 sm:w-18 sm:h-18 md:w-20 md:h-20 bg-white rounded-xl flex items-center justify-center">
                  <img src={`/images/icons/earth.png`} alt="icon" className="h-8 sm:h-10 md:h-12 rounded-lg" />
                </div>
                <div className="flex-1">
                  <h3 className="text-sm sm:text-base md:text-lg mb-2 text-white font-semibold leading-tight">
                    {t('steps.step1.title')}
                  </h3>
                  <p className="text-[#D7D7D7] font-extralight text-xs sm:text-sm leading-relaxed sm:leading-normal tracking-wide">
                    {t('steps.step1.desc')}
                  </p>
                </div>
              </div>

              {/* Step 2 */}
              <div className="flex items-start space-x-3 sm:space-x-4">
                <div className="flex-shrink-0 w-16 h-16 sm:w-18 sm:h-18 md:w-20 md:h-20 bg-white rounded-xl flex items-center justify-center">
                  <img src={`/images/icons/search.png`} alt="icon" className="h-8 sm:h-10 md:h-12 rounded-lg" />
                </div>
                <div className="flex-1">
                  <h3 className="text-sm sm:text-base md:text-lg mb-2 text-white font-semibold leading-tight">
                    {t('steps.step2.title')}
                  </h3>
                  <p className="text-[#D7D7D7] font-extralight text-xs sm:text-sm leading-relaxed sm:leading-normal tracking-wide">
                    {t('steps.step2.desc')}
                  </p>
                </div>
              </div>

              {/* Step 3 */}
              <div className="flex items-start space-x-3 sm:space-x-4">
                <div className="flex-shrink-0 w-16 h-16 sm:w-18 sm:h-18 md:w-20 md:h-20 bg-white rounded-xl flex items-center justify-center">
                  <img src={`/images/icons/call.png`} alt="icon" className="h-8 sm:h-10 md:h-12 rounded-lg" />
                </div>
                <div className="flex-1">
                  <h3 className="text-sm sm:text-base md:text-lg mb-2 text-white font-semibold leading-tight">
                    {t('steps.step3.title')}
                  </h3>
                  <p className="text-[#D7D7D7] font-extralight text-xs sm:text-sm leading-relaxed sm:leading-normal tracking-wide">
                    {t('steps.step3.desc')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}